import { render, staticRenderFns } from "./CardAccordion.vue?vue&type=template&id=1fdbd95d"
import script from "./CardAccordion.vue?vue&type=script&lang=js"
export * from "./CardAccordion.vue?vue&type=script&lang=js"
import style0 from "./CardAccordion.vue?vue&type=style&index=0&id=1fdbd95d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports